// Debug mode parameter
export const DEBUG_ENABLED_FLAG_QUERY_PARAM = 'debug';

export const REORDER_CTA_QUERY_PARAM = 'reorderCta';

// Query parameters used in the order history fragment
export const ORDER_HISTORY_QUERY_PARAMS = [
  DEBUG_ENABLED_FLAG_QUERY_PARAM,
  REORDER_CTA_QUERY_PARAM,
];
